module.exports = __webpack_public_path__ + "static/media/search_32.fa10b6e0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/search_32.svg
// module id = 561
// module chunks = 0